import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, Workspace } from '@mayksel/types';
import { setWorkspaceLabels } from '../i18n/index.js';

interface WorkspaceState {
  workspace: Workspace | null;
  user: User | null;
  isLoading: boolean;
  setWorkspaceData: (workspace: Workspace, user: User) => void;
  clearWorkspace: () => void;
  setLoading: (loading: boolean) => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      workspace: null,
      user: null,
      isLoading: true,

      setWorkspaceData: (workspace, user) => {
        setWorkspaceLabels({
          bucket: workspace.bucketLabel,
          bucket_plural: workspace.bucketLabelPlural,
          order: workspace.orderLabel,
          order_plural: workspace.orderLabelPlural,
        });
        set({ workspace, user, isLoading: false });
      },

      clearWorkspace: () => set({ workspace: null, user: null, isLoading: false }),

      setLoading: (loading) => set({ isLoading: loading }),
    }),
    {
      name: 'mayksel-workspace',
      partialize: (state) => ({
        workspace: state.workspace,
        user: state.user,
      }),
    },
  ),
);
